export default __webpack_public_path__ + "static/media/shield-coin.e9f28ec2.png";